import { render, staticRenderFns } from "./ForgetPasswd.vue?vue&type=template&id=07d3c3c0&"
import script from "./ForgetPasswd.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswd.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports